import { render, staticRenderFns } from "./PartesTerrestres.vue?vue&type=template&id=ffa18756&"
import script from "./PartesTerrestres.vue?vue&type=script&lang=js&"
export * from "./PartesTerrestres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports